import { FormikValues, useFormik } from "formik";
import { RequestTemplateForCreatingEventDto } from "@app/data/tribeSwaggerApi";
import React, { FC } from "react";
import { z, ZodSchema } from "zod";
import { StepMachineState } from "@pages/makeEvent/types/useStepMachine";
import { CreateEventInfo } from "@app/data/createEvent/types";
import { EventAddressDto } from "@app/data/tribeSwaggerApi";

export type TMakeStepChangeVariables = "-" | "+" | "confirm" | "invite" | "invite_confirm"

export type TStepVariables = 1 | 2 | 3 | 4 | 5 | "confirm" | "invite" | "invite_confirm"

export type TStepProps = {
  formik: Formik<CreateEventInfo>
  isConfirm?: boolean
  handlerClose?: () => void
  stepController: StepMachineState
}

export type AddressComponentProps ={
  formik: Formik<CreateEventInfo>
  setValidAddress: (data: EventAddressDto) => void
}

export type EventTypeComponentProps ={
  formik: Formik<CreateEventInfo>
  setValidValue: (value: number) => void
}

export type EventNameComponentProps ={
  formik: Formik<CreateEventInfo>
  setValidValue: (value: string) => void
}

export type EventModeComponentProps ={
  formik: Formik<CreateEventInfo>
  setValidValue: (value: boolean) => void
}

export type EventDateComponentProps ={
  formik: Formik<CreateEventInfo>
  setValidValue: (name: string) => (value: string) => void
}

export type EventDescriptionComponentProps ={
  formik: Formik<CreateEventInfo>
  setValidDescription: (value: string) => void
}

export type EventAddPhotoComponentProps ={
  formik: Formik<CreateEventInfo>
  addPhoto: (imgArrBuf: string, imgDataUrl: string, pos: number) => void
	photo: Array<string>
  setHasValidPhoto: (value: boolean) => void
}

export type EventConditionsComponentProps ={
  formik: Formik<CreateEventInfo>
}

type Formik<T extends FormikValues> = ReturnType<typeof useFormik<T>>

export type TUser = {
  id: number
  user_avatar: string
  username: string
  last_name: string
  first_name: string
}

export type TImageUploaded = {
  imgArrBuf: string
  imgDataUrl: string
}
export interface WizardScreenProps<T> {
  schema: ZodSchema<T>;
  prev: () => void;
  next: (data?: T) => void;
}

export const initFormValues = (): CreateEventInfo => (
  {
    event_name: "",
    event_address: {
      city: "",
      region: "",
      street: "",
      event_longitude: 0,
      event_latitude: 0,
      house_number: "",
    },
    start_time: "",
    event_type_id: 0,
    end_time: "",
    description: "",
    show_event_in_search: true,
    is_private: null,
    has_alcohol: false,
    avatars_for_adding: [],
    send_to_all_users_by_interests: false,
    is_eighteen_year_limit: false,
    is_free: true,
  }
)
export type ScreenComponent<T> = React.FC<WizardScreenProps<T>>
